import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {SurveyModule} from "survey-angular-ui";
import {SurveyModel} from 'survey-core';
import {firstValueFrom} from "rxjs";
import {SurveyService} from "../../services/survey.service";

/** All error pages showed in the surveys */
@Component({
	selector: 'app-error',
	imports: [SurveyModule],
	templateUrl: './error.component.html',
	styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnInit, OnDestroy {
	/** The currently displayed SurveyJS survey */
	model:SurveyModel;

	constructor(private activatedRoute:ActivatedRoute,
	            private surveyService:SurveyService) {
	}

	async ngOnInit():Promise<void> {
		this.model = this.surveyService.newSurvey();

		const params = await firstValueFrom(this.activatedRoute.paramMap);

		const errorReason:string = params.get('error-reason');

		switch(errorReason) {
			case "SurveyLinkAccessRevoked":
				this.model.fromJSON(this.surveyService.commonModules.errorSurveyAccessRevoked);
				break;
			case "SurveyAlreadyFinished":
				this.model.fromJSON(this.surveyService.commonModules.errorSurveyAlreadyFinished);
				break;
			default:
				this.model.fromJSON(this.surveyService.commonModules.errorDefault);
				break;
		}
	}

	ngOnDestroy() {
		this.model.dispose();
	}
}

